import createIcon from '../../createIcon';

/**
 * @component @name ViewCarousel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiA3SDZWMTdIMlY3Wk03IDE5SDE3VjVIN1YxOVpNMTggN0gyMlYxN0gxOFY3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewCarousel = createIcon('ViewCarousel', [
  ['path', { d: 'M2 7H6V17H2V7ZM7 19H17V5H7V19ZM18 7H22V17H18V7Z', key: '58ogly' }],
]);

export default ViewCarousel;
